import { pianoAnalytics as pa } from 'piano-analytics-js'

import { settings } from '../../app.settings';

class Tracking {
  site: string;
  domain: string;

  constructor() {
    this.site = settings.pianoAnalytics.site;
    this.domain = settings.pianoAnalytics.collectDomain;

    this.init();
  }

  init() {
    this.call('setConfigurations', {
      site: this.site,
      collectDomain: this.domain || 'lbgrcmm.pa-cd.com',
    });

    pa.privacy.setMode('cnil', 'exempt');
  }

  setUser(...args: any[]) {
    this.call('setUser', ...args);
  }

  sendEvent(...args: any[]) {
    this.call('sendEvent', ...args);
  }

  private call(method: string, ...args: any[]) {
    if (!this.site || this.site === 'undefined') {
      return
    }

    pa[method].apply(pa, args);
  }
}

const instance = new Tracking()

export default instance
